var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadOrangeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44164 9.62791C6.67141 9.8149 7.00088 9.8149 7.23065 9.62791L9.58854 7.70901C9.85627 7.49113 9.89668 7.09747 9.6788 6.82974C9.46092 6.56202 9.06726 6.52161 8.79953 6.73949L7.46115 7.8287L7.46114 1.55737C7.46114 1.21219 7.18132 0.932373 6.83614 0.932373C6.49097 0.932373 6.21114 1.21219 6.21114 1.55737L6.21115 7.8287L4.87276 6.73949C4.60503 6.52161 4.21137 6.56202 3.9935 6.82974C3.77562 7.09747 3.81602 7.49113 4.08375 7.70901L6.44164 9.62791ZM1.53125 11.4511C1.18607 11.4511 0.90625 11.731 0.90625 12.0761C0.90625 12.4213 1.18607 12.7011 1.53125 12.7011H12.4688C12.8139 12.7011 13.0938 12.4213 13.0938 12.0761C13.0938 11.731 12.8139 11.4511 12.4688 11.4511H1.53125Z",
    fill: "#E55916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOrangeSmall);
export default __webpack_public_path__ + "static/media/DownloadOrangeSmall.ee29e426060bc546826a86a8fabdb73a.svg";
export { ForwardRef as ReactComponent };